import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { CustomersSearch } from "@/sections/customer/customers-search";
import { useGetAdvertisementQuery } from "@/app/features/advertisement/advertisementApiSlice";
import AdvertismentModal from "@/pages/advertisement/components/AdvertismentModal";
import AdvertisementListing from "@/pages/advertisement/components/AdvertisementListing";

export default function AdvertisementPage() {
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const { data, isLoading, isFetching, error } = useGetAdvertisementQuery({
    page: paginationModel.page + 1,
    limit: paginationModel.pageSize,
    search: search,
  });

  const [rowCountState, setRowCountState] = useState(data?.count || 0);

  const [selectedAdvertisement, setselectedAdvertisement] = useState({});
  const [isAdvertisementModalOpen, setisAdvertisementModalOpen] =
    useState(false);

  const handleSelectedAdvertisementModalClose = () => {
    setisAdvertisementModalOpen(false);
  };

  const handleSelectAdvertisement = (advertisement) => {
    setselectedAdvertisement(advertisement);
    setisAdvertisementModalOpen(true);
  };

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      data?.data?.total !== undefined ? data?.data?.total : prevRowCountState
    );
  }, [data, isLoading]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      {selectedAdvertisement && (
        <AdvertismentModal
          open={isAdvertisementModalOpen}
          handleClose={handleSelectedAdvertisementModalClose}
          selectedAdvertisement={selectedAdvertisement}
        />
      )}

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Advertisement</Typography>
            <Button
              color="inherit"
              startIcon={
                <SvgIcon fontSize="small">
                  <ArrowUpOnSquareIcon />
                </SvgIcon>
              }
              variant="contained"
              component={Link}
              to="/advertisement/create"
              // onClick={() => setIsAdvertismentModalOpem(true)}
            >
              Add
            </Button>
          </Stack>
          <CustomersSearch search={search} setSearch={setSearch} />
          <AdvertisementListing
            isLoading={isLoading || isFetching}
            error={error}
            data={data?.data}
            rowCountState={rowCountState}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSelectAdvertisement={handleSelectAdvertisement}
          />
        </Stack>
      </Container>
    </Box>
  );
}
